import { Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd } from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
import { uppercaseChar6lahngw3wvwg as uppercaseChar } from './charJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function titlecaseCharImpl(_this__u8e3s4) {
  // Inline function 'kotlin.code' call
  var code = Char__toInt_impl_vasixd(_this__u8e3s4);
  if ((452 <= code ? code <= 460 : false) || (497 <= code ? code <= 499 : false)) {
    return numberToChar(imul(3, (code + 1 | 0) / 3 | 0));
  }
  if ((4304 <= code ? code <= 4346 : false) || (4349 <= code ? code <= 4351 : false)) {
    return _this__u8e3s4;
  }
  return uppercaseChar(_this__u8e3s4);
}
//region block: exports
export {
  titlecaseCharImpl as titlecaseCharImpli42cc4hnceu7,
};
//endregion

//# sourceMappingURL=_TitlecaseMappings.mjs.map
